var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretDownBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow/drop-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MENU-FLOTANTE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "translate(-247.000000, -257.000000)",
    stroke: "#003965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(32.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow/drop-down",
    transform: "translate(220.000000, 12.000000) rotate(90.000000) translate(-220.000000, -12.000000) translate(218.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    transform: "translate(2.000000, 4.000000) rotate(90.000000) translate(-2.000000, -4.000000) ",
    points: "-2 6 2.01200295 2 6 6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownBlue);
export default __webpack_public_path__ + "static/media/caret-down-blue.588d14e96d9bde58fb52e24b4b4aba64.svg";
export { ForwardRef as ReactComponent };